'use client';

import React, { Component } from 'react';
import './style.sass';

import Frame from '../reusable-components/layouts-components__topdf/frame';
import Results from '../reusable-components/layouts-components__topdf/results';
import Tasks from '../reusable-components/layouts-components__topdf/tasks';
import PortfolioGallery from '../reusable-components/layouts-components__topdf/portfolio-gallery';
import Goals from '../reusable-components/layouts-components__topdf/goals';
import Process from '../reusable-components/layouts-components__topdf/process';
import Complex from '../reusable-components/layouts-components__topdf/complex';
import Team from '../reusable-components/layouts-components__topdf/team';
import NextProject from '../reusable-components/layouts-components__common-cases/next-project';

import FullWrapper from '../reusable-components/layouts-components__common-cases/full-wrapper';
import MainTitle from '../reusable-components/layouts-components__common-cases/main-title';

import ScrollAnimation from '../../../../../core/ScrollAnimation';
import OfferButton from '../../../../../shared/sections/OfferButton';
import CommonSmallText from '../common-components/common-small-text';
import CommonSmallTitle from '../common-components/common-small-title';

const gensMainTitle = {
    titleMainText: `2pdf.com&nbsp;&mdash; платформа для&nbsp;работы с&nbsp;PDF-файлами`,
    titleAnimation: '/images/pic/preview/2pdf.png',
    subtitleContainer: [
        {
            modeText: 'клиент',
            colorMode: '#c1272d',
            nameText: 'Вебпрактик',
        },
        {
            modeText: 'Отрасль',
            colorMode: '#c1272d',
            nameText: 'Технологии',
        },
        {
            modeText: 'Услуги',
            colorMode: '#c1272d',
            nameText: 'Создание и&nbsp;запуск сервиса на&nbsp;международный рынок',
        },
        {
            modeText: 'Технологии',
            colorMode: '#c1272d',
            nameText:
                'Node.js, NestJS, RabbitMQ, SSR, React, SPA, Microservice, CodeceptJS, Kubernetes, Helm',
        },
    ],
};

const nextProjectGens = {
    product: true,
    nextProjectTitle: 'Создание и запуск платформы linkbuilder.ai',
    nextProjectImg: '/images/svg/projects/projects__img1.png',
    nextProjectLink: '/cases/products/linkbuilder',
    nextProjectLinkTitle: 'linkbuilder.ai',
    nextProjectText:
        'Сервис для автоматизированного линкбилдинга, который упрощает и ускоряет процесс нарощения ссылочной массы сайта',
};

class ToPdf extends Component {
    render() {
        return (
            <section className="topdf">
                <MainTitle MainTitle={gensMainTitle}>
                    <CommonSmallTitle className="topdf__subtitle">2PDF</CommonSmallTitle>
                    <CommonSmallText>
                        Это собственный сервис компании для работы с&nbsp;PDF, который позволяет
                        делать все необходимые операции с&nbsp;PDF-файлами в&nbsp;несколько кликов.
                        Запустились в&nbsp;марте 2020&nbsp;года. На&nbsp;момент запуска сервис
                        позволяет конвертировать PDF в&nbsp;65&nbsp;форматов и&nbsp;переводить
                        из&nbsp;94&nbsp;различных форматов.
                    </CommonSmallText>
                </MainTitle>
                <Frame />
                <Goals />
                {/*//todo*/}
                <PortfolioGallery />
                <Tasks />
                <Complex />
                <Process />
                <Results />
                <Team />
                <ScrollAnimation animateIn="zoomIn" offset={50} animateOnce={true} duration={1}>
                    <FullWrapper>
                        <OfferButton linkText="Нанять команду" />
                    </FullWrapper>
                </ScrollAnimation>
                <NextProject NextProject={nextProjectGens} />
            </section>
        );
    }
}

export default ToPdf;
